module.exports = __webpack_public_path__ + "AdobeStock_427032931.jpg?7cf80971465db9d71659b078306c20c0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/AdobeStock_427032931.jpg
// module id = 64
// module chunks = 0